import React from 'react';
import {
  AAMBeaconIconButton,
  AAMBeaconMenu,
  AAMBeaconPopover,
  AAMBeaconTableStub
} from "components/shared/Beacon";
import { FormattedDate } from 'components/shared/Text/Text';
import { ReactComponent as MoreElipsis } from 'assets/icons/more-elipsis.svg';

/*
  This is the utility function for creating the table rows and headers that
  will be used in the transaction history table. This takes in the raw
  transaction history data and the taxonomy information that are both included
  in the /activity/historical-transactions endpoint.

  TODO: Add pagination to the table
  TODO: Add filtering based on selected filters
 */
export const buildTransactionHistoryTable = (rawTransactionHistory, agreements = [], filters) => {
  /*
    TODO: Apply the filters to the transaction history here before building the table rows
  */
  console.log(filters);
  return {
    headers: [
      {
        id: 'transaction-history-action-header',
        title: 'Action',
        variant: 'group'
      },
      {
        id: 'transaction-history-trade-date-header',
        title: 'Trade date',
        variant: 'group'
      },
      {
        id: 'transaction-history-type-header',
        title: 'Type',
        variant: 'group'
      },
      {
        id: 'transaction-history-account-header',
        title: 'Account',
        variant: 'group'
      },
      {
        id: 'transaction-history-security-header',
        title: 'Security',
        variant: 'group'
      },
      {
        id: 'transaction-history-quantity-header',
        className: 'right-align-content',
        title: 'Quantity',
        variant: 'group'
      },
      {
        id: 'transaction-history-price-header',
        className: 'right-align-content',
        title: 'Price',
        variant: 'group'
      },
      {
        id: 'transaction-history-amount-header',
        className: 'right-align-content',
        title: 'Amount',
        variant: 'group'
      }
    ],
    rows: rawTransactionHistory.map((transaction) => {
      // Pull the associated account information out of the included accounts
      const associatedAgreeemnt = agreements.find((agreement) => {
        return agreement.uniqueId === transaction.agreementUniqueId;
      })

      //TODO: Update the styles for these cells,
      // the data should already be getting pulled
      // from the correct area

      // TODO: any custom styles (not beacon utilities can be included in the Transaction history table scss file.
      //  But we should prioritize using the Beacon utility classes for all styles moving forward

      // uniqueTransactionHistoryId is in the array set open to true
      return {
        rowArray: [
          {
            record:(
                <div>
                  <AAMBeaconIconButton id="history-transactions-actions-popover-trigger" variant='tertiary' aria-label="Transaction history actions elipsis">
                    <MoreElipsis slot="icon"/>
                  </AAMBeaconIconButton>
                  <AAMBeaconPopover
                      opens-by="#history-transactions-actions-popover-trigger"
                      placement='bottom-start'
                  >
                    <AAMBeaconMenu>
                      <ul>
                        <li>Option 1</li>
                        <li>Option 2</li>
                      </ul>
                    </AAMBeaconMenu>
                  </AAMBeaconPopover>
                </div>
            ),
            variant: 'text'
          },
          {
            record: <FormattedDate className={'b-typography-sans-serif--body--100 b-font-weight-bold'}>{transaction.tradeDate}</FormattedDate>,
            variant: 'text'
          },
          {
            record: <div className={'b-typography-sans-serif--body--100 b-font-weight-light'}>{transaction.typeName}</div>,
            variant: 'text'
          },
          {
            record: (
              <div>
                <div className={'b-typography-sans-serif--body--100 b-font-weight-light'}>{associatedAgreeemnt?.accountName}</div>
                <div className={'b-typography-sans-serif--body--100 b-font-weight-light'}>{associatedAgreeemnt?.agreementNumberDisplay}</div>
              </div>
            ),
            variant: 'text'
          },
          {
            record: (
              <div>
                <div className={'b-typography-sans-serif--caption--200 b-font-weight-bold'}>{transaction?.investmentVehicleKey?.ticker}</div>
                <div className={'b-typography-sans-serif--body--100 b-font-weight-light'}>
                  {transaction?.investmentVehicleKey?.investmentName ? transaction?.investmentVehicleKey?.investmentName : "N/A"}
                </div>
              </div>
            ),
            variant: 'text'
          },
          {
            record: <div className={'right-align-content b-typography-sans-serif--body--100 b-font-weight-light nowrap-align'}>
                      {transaction.shares}
                      </div>,
            variant: 'text'
          },
          {
            record: <div className={'right-align-content b-typography-sans-serif--body--100 b-font-weight-bold nowrap-align'}>
                      ${transaction.sharePrice}
                    </div>,
            variant: 'text'
          },
          {
            record: <div className={'right-align-content b-typography-sans-serif--body--100 b-font-weight-bold nowrap-align'}>
                      ${transaction.amount}
                    </div>,
            variant: 'text'
          }
        ]
      }
    })
  };
}

export const initialTransactionsHistoryFilteringStateV2 = {
  dateOptions: {},
  timePeriod: {
    selection: '90',
    options: [
      {
        label: 'Past 10 Days',
        value: '10'
      },
      {
        label: 'Past 30 Days',
        value: '30'
      },
      {
        label: 'Past 60 Days',
        value: '60'
      },
      {
        label: 'Past 90 Days',
        value: '90'
      },
      {
        label: 'Past 180 Days',
        value: '180'
      },
      {
        label: 'Past 1 Year',
        value: '365'
      },
      {
        label: 'Past 2 Years',
        value: '730'
      },
      {
        label: 'All (Up to 3 Years)',
        value: '1095'
      }
    ]
  },
  includedAccounts: {
    selection: 1,
    options: [
      {
        id: 1,
        label: 'All Accounts',
        value: 'all'
      }
    ]
  },
  transactionType: {
    selection: 'all',
    options: [
      {
        label: 'All Transaction Types',
        value: 'all'
      }
    ]
  }
};

/*
  This is the utility function for creating the table rows and headers used in
  the transaction pending table.

  TODO: Add pagination to the table
  TODO: Add filtering based on selected filters
 */
export const buildTransactionPendingTable = (rawTransactionPending, agreements = [], filters) => {
  /*
    TODO: Apply the filters to the transaction pending here before building the table rows
  */
  console.log(filters);
  return {
    headers: [
      {
        id: 'transaction-pending-action-header',
        title: 'Action',
        variant: 'group'
      },
      {
        id: 'transaction-pending-submission-date-header',
        className: 'nowrap-align',
        title: 'Submission date',
        variant: 'group'
      },
      {
        id: 'transaction-pending-type-header',
        title: 'Type',
        variant: 'group'
      },
      {
        id: 'transaction-pending-account-header',
        title: 'Account',
        variant: 'group'
      },
      {
        id: 'transaction-pending-security-header',
        title: 'Security',
        variant: 'group'
      },
      {
        id: 'transaction-pending-amount-header',
        className: 'right-align-content',
        title: 'Amount',
        variant: 'group'
      },
      {
        id: 'transaction-pending-status-header',
        className: 'right-align-content',
        title: 'Status',
        variant: 'group'
      }
    ],
    rows: rawTransactionPending.map((transaction) => {
      // Pull the associated account information out of the included accounts
      const associatedAgreement = agreements.find((agreement) => {
        return agreement.uniqueId === transaction?.agreementUniqueId;
      })

      // uniqueTransactionPendingId is in the array set open to true

      return {
        rowArray: [
          {
            record: (
                <div>
                  <AAMBeaconIconButton id="pending-transactions-actions-popover-trigger" variant='tertiary' aria-label="Transaction history actions elipsis">
                    <MoreElipsis slot="icon"/>
                  </AAMBeaconIconButton>
                  <AAMBeaconPopover
                      opens-by="#pending-transactions-actions-popover-trigger"
                      placement='bottom-start'
                  >
                    <AAMBeaconMenu>
                      <ul>
                        <li>Option 1</li>
                        <li>Option 2</li>
                      </ul>
                    </AAMBeaconMenu>
                  </AAMBeaconPopover>
                </div>
            ),
            variant: 'text'
          },
          {
            record: <FormattedDate className={'b-typography-sans-serif--body--100 b-font-weight-bold'}>{transaction.submissionDate}</FormattedDate>,
            variant: 'text'
          },
          {
            record: <div className={'b-typography-sans-serif--body--100 b-font-weight-light'}>{transaction.type}</div>,
            variant: 'text'
          },
          {
            record: (
                <div>

                  <div className={'b-typography-sans-serif--body--100 b-font-weight-light'}>{associatedAgreement?.accountName}</div>
                  {/*<div className={'b-typography-sans-serif--body--100 b-font-weight-light'}>{associatedAgreement?.agreementName}</div>*/}
                  <div className={'b-typography-sans-serif--body--100 b-font-weight-light'}>{associatedAgreement?.agreementNumberDisplay}</div>
                </div>
            ),
            variant: 'text'
          },
          {
            record: (
                <div>
                    <div className={'b-typography-sans-serif--caption--200 b-font-weight-bold'}>{transaction?.securityId}</div>
                    <div className={'b-typography-sans-serif--body--100 b-font-weight-light'}>{transaction?.securityDescription ? transaction?.securityDescription : 'N/A'}</div>
                </div>
            ),
            variant: 'text'
          },
          {
            record: (
                <div className={'right-align-content b-typography-sans-serif--caption--200 b-font-weight-bold nowrap-align'}>
                  {transaction.amount}
                </div>
            ),
            variant: 'text'
          },
          {
            record: (
                <AAMBeaconTableStub className={'nowrap-align'}>
                  <span slot="status">{transaction.status}</span>
                </AAMBeaconTableStub>
            ),
            variant: 'text'
          }
        ]
      }
    })
  };
}
